import React from "react";
import { InputRadio, Type } from "@ebscois/react-component-library";
import {
  StyledDialogContainer,
  StyledDialogHeading,
  StyledDialogMessage,
  StyledInputGroup,
  StyledTypeButtonWrapper,
  StyledSaveButton,
  StyledCancelButton,
  StyledRadioGroupWrapper,
} from "./_.styled";

const FollowDialog = ({
  isOpen,
  onRequestClose,
  onSave,
  subscriptionOptions = [],
}) => {
  const defaultOption =
    subscriptionOptions.length > 0
      ? subscriptionOptions[0].subscriptionType
      : null;

  const [selectedValue, setSelectedValue] = React.useState(defaultOption);

  const handleChange = (event) => {
    const value = event.target.value;
    setSelectedValue(value);
  };

  const handleSave = () => {
    if (onSave) {
      onSave(selectedValue);
    }
  };

  // reset selected value to first option when dialog is closed
  React.useEffect(() => {
    if (!isOpen && selectedValue) {
      setSelectedValue(defaultOption);
    }
  }, [defaultOption, isOpen, selectedValue]);

  return (
    <StyledDialogContainer
      data-testid="dialog-container"
      onRequestClose={onRequestClose}
      isOpen={isOpen}
      maxWidth="sm"
    >
      <StyledDialogHeading element="h2">Follow</StyledDialogHeading>
      <StyledDialogMessage element="p">
        Get alerts when there are significant updates to this content.
      </StyledDialogMessage>
      {subscriptionOptions?.length > 0 && (
        <StyledRadioGroupWrapper>
          <Type
            element="legend"
            data-testid="dialog-select-options"
            fontWeight="bold"
          >
            Select:
          </Type>
          <StyledInputGroup
            data-testid="radiobutton-group"
            onChange={handleChange}
            selectedValue={selectedValue}
          >
            {subscriptionOptions.map(({ text, subscriptionType }) => (
              <InputRadio
                key={subscriptionType}
                id={subscriptionType}
                label={text}
                name="selection"
                value={subscriptionType}
              />
            ))}
          </StyledInputGroup>
        </StyledRadioGroupWrapper>
      )}
      <StyledTypeButtonWrapper>
        <StyledSaveButton
          data-testid="follow-dialog-follow-button"
          onClick={handleSave}
          size="md"
          data-auto="follow-modal__follow-button"
          disabled={!selectedValue}
        >
          Follow
        </StyledSaveButton>
        <StyledCancelButton onClick={onRequestClose} size="md" kind="text">
          Cancel
        </StyledCancelButton>
      </StyledTypeButtonWrapper>
    </StyledDialogContainer>
  );
};

FollowDialog.displayName = "FollowDialog";

export default FollowDialog;
